<script>
import {
  CdrText, CdrLink,
} from '@rei/cedar';

export default {
  name: 'SeriesTile',
  components: {
    CdrText, CdrLink,
  },
  props: {
    uri: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    baseClassName: 'series-tile',
  }),
};
</script>

<template>
  <cdr-link
    tag="a"
    :href="`${uri}`"
    modifier="standalone"
    :class="`${baseClassName}`"
  >
    <div>
      <cdr-text :class="`${baseClassName}__eyebrow`">
        <slot name="default" />
      </cdr-text>
      <cdr-text
        tag="p"
        data-test-id="title"
        :class="`${baseClassName}__title`"
      >
        <span>{{ title }}</span>
      </cdr-text>
      <cdr-text
        v-if="description"
        data-test-id="body"
        :class="`${baseClassName}__body`"
      >
        <span>{{ description }}</span>
      </cdr-text>
    </div>
  </cdr-link>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

  $baseClassName: 'series-tile';

  a.#{$baseClassName} {
    height: 100%;
    width: 100%;
    border: 1px solid $cdr-color-border-secondary;
    padding: $cdr-space-three-quarter-x;
    display: inline-block;
    color: inherit;
    &:hover {
      text-decoration: none;
    }

    .#{$baseClassName}__eyebrow {
      @include cdr-text-eyebrow-100;
      margin: 0;
      display: inline-block;
    }
    .#{$baseClassName}__title {
      @include cdr-text-heading-serif-300;
      margin: $cdr-space-half-x 0 0 0;
    }
    .#{$baseClassName}__body {
      @include cdr-text-body-300;
      margin: $cdr-space-half-x 0 0 0;
    }
  }

</style>
